import { AxiosInstance } from 'axios';
import { AppInfo } from './global-app-store';
import { getStorage, replaceCdnDomain } from './utils';
import { IApp } from './types';

const STORE_NAMESPACE = '_micro_app_store_name_space';

export const getApp = async (appId: number): Promise<AppInfo> => {
  const axiosInstance: AxiosInstance = window['SYSTEM_AXIOS'] || window['axios'];

  // 先找缓存
  let appModule = window[STORE_NAMESPACE]?.[appId];
  if (appModule) {
    // 如果systemjs 已经import过 entry资源
    if (appModule.umd && appModule.umd.default) {
      console.info('in getApp, find cache', appId, appModule);
      return appModule;
    }
    // 如果存在js entry 就 使用system import 资源
    if (appModule.jsEntry) {
      const jsEntry = appModule.jsEntry;
      appModule.umd = await (window['MicroSystem'] || (window as any).System).import(jsEntry);
      console.info('in getApp, js entry not imported, end import', appId, appModule);
      return appModule;
    }
  } else {
    // 未请求js资源
    let appInfo = {};
    try {
      const res = await axiosInstance.post('/rest/application/relation/getAppResourceById', {
        appId,
      });
      console.info('======== new in getApp, request /getAppResourceById  sent, res is======', res);
      if (res?.data?.result === 1) {
        appInfo = res.data.data;
      } else {
        console.log('================ get app info from local storage ================');
        // 接口拉取应用资源失败，走本地缓存
        const appList = getStorage('crm_v2_child_app_list');
        appInfo = appList?.find((app: any) => app?.appId === appId);
      }
    } catch (error) {
      console.log('获取单个子应用信息失败');
    }
    const data = replaceCdnDomain([appInfo])?.[0];
    //如果jsEntry不存在怎么办
    const appResource = data.jsEntry?.[0];
    console.info('in getApp start import js');
    const sTime = new Date().getTime();
    const umd = await (window['MicroSystem'] || (window as any).System).import(appResource);
    appModule = {
      id: appId,
      umd: umd,
      basename: data.appBasename,
      jsEntry: appResource,
      cssEntry: data.cssEntry,
    };
    // 如果存在全局store 则进行更新
    if (window[STORE_NAMESPACE]) {
      window[STORE_NAMESPACE][appId] = appModule;
    }
    console.info('in getApp end download and import js');
    console.info('in getApp time', new Date().getTime() - sTime);
    console.info('in getApp, appMoudle from /getAppResourceById', appModule);
    //@ts-ignore
    console.info('in getApp _micro_app_store_name_space', window['_micro_app_store_name_space']);
  }
  return appModule;
};

export const SharedModuleMap: {
  [key: string]: { sharedModules: any; appResource: IApp };
} = {};

export const getSharedModule = async (appId: number) => {
  if (SharedModuleMap[appId]) {
    return SharedModuleMap[appId];
  } else {
    try {
      // 首次需要获取资源并执行
      // const res = await getAppResourceById({ appId });
      // if (res) {
      const module = await getApp(appId);
      console.log('function getSharedModule:', module);

      const sharedModule = {
        sharedModules: module.umd?.default.SharedModules,
        appResource: {
          cssEntry: [module.cssEntry],
        },
      };
      //@ts-ignore
      SharedModuleMap[appId] = sharedModule;
      return sharedModule;
      // }
    } catch (error) {
      console.error('获取应用资源信息失败~');
    }
  }
};
